module.exports = __webpack_public_path__ + "static/media/img3-4.29695869.png";